/** @format */

import React, { useState } from 'react';
import { Enviroment } from '../../_config/constants/enviroment-v2.constant';
import { CountryImage } from '../../_config/constants/image-country.constant';
import './style.scss'

export default function Images(props) {
	const [isError, setError] = useState(false);
	const [imgSuccess] = useState(props.src);
	const [imgError] = useState(CountryImage[Enviroment.LANGUAGE].notFound);
	const handleError = () => {
		console.log('handleError', imgError);
		setError(true);
	};

	return (
		<>
			<picture className={props.classContent}>
				<img className={props.classImage}  src={isError === true ? imgError : imgSuccess} onError={handleError} alt={props.alt} {...props} />
			</picture>
		</>
	);
}
